import { useEffect, useRef, useState } from "react";
import { Icon } from "../ui/Icon";

/** How long typing has to stop before the search runs, in ms. */
const WAIT_MS = 300;

/** A list page's search (`.k-q`): it runs a moment after typing stops; Escape or the x clears it. */
export function Search({
  placeholder,
  label,
  initial = "",
  onSearch,
}: {
  placeholder: string;
  /** What it searches, for a screen reader. */
  label: string;
  initial?: string;
  /** Called with the words trimmed, and with "" when cleared. */
  onSearch: (query: string) => void;
}) {
  const [value, setValue] = useState(initial);
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
  useEffect(() => () => clearTimeout(timer.current), []);
  const clear = () => {
    clearTimeout(timer.current);
    setValue("");
    onSearch("");
  };
  return (
    <label className="k-q">
      <Icon name="search" />
      <input dir="auto"
        type="search"
        value={value}
        placeholder={placeholder}
        aria-label={label}
        autoComplete="off"
        enterKeyHint="search"
        onChange={(e) => {
          const next = e.target.value;
          setValue(next);
          clearTimeout(timer.current);
          timer.current = setTimeout(() => onSearch(next.trim()), WAIT_MS);
        }}
        onKeyDown={(e) => {
          if (e.key !== "Escape") return;
          clear();
          e.currentTarget.blur();
        }}
      />
      {value ? (
        <button type="button" className="k-qx" aria-label="Clear" onClick={clear}>
          <Icon name="x" />
        </button>
      ) : null}
    </label>
  );
}
